export default "__VITE_ASSET__DB61xkl4__"